import React, { useEffect } from 'react'
import { useState } from "react";
import { Collapse } from "reactstrap";
import { setAnalyticsEvent } from '../../core/helpers/analytics';
import ReactGA from "react-ga4";

export default function Faq(props) {
    const [answers, setAnswers] = useState(new Array(props.faqs.length).fill(false));

    useEffect(()=>{
        const locationHash = window.location.hash;
          ReactGA.send({ hitType: 'pageview', page_location: `${locationHash}` });
          {
            process.env.REACT_APP_RENDER_GA === "true" &&
            setAnalyticsEvent(locationHash, `${locationHash}`);
          }
    },[])
    

    const toggle = (ans) => {
        let answer = answers;
        answer[ans] = !answer[ans];
        setAnswers([...answer]);
    };

    return <div className="faq-section">
        {props.faqs.map((item, index) => (
            <div className="faq" key={index}>
                <div className="question" onClick={() => toggle(index)}>
                    {item.ques}
                    <img
                        src={process.env.REACT_APP_IMAGES_PATH + "chevronCircledDown.webp"}
                        alt="arrow"
                        className={answers[index]
                            ? "down-arrow mb-1 ml-2"
                            : "ml-2"}
                    />
                </div>
                <Collapse isOpen={answers[index]} key={Date()}>
                    <p className="answer" dangerouslySetInnerHTML={{__html: item.ans}} />
                    {(item.imgweb || item.imgmob) && <img
                        src={!props.isMobile ? item.imgweb : item.imgmob}
                        alt="img"
                        className="faq-img"
                    />}
                </Collapse>
            </div>
        ))}
    </div>
}